import React, { useState } from 'react';

export const ServiceCard = ({ service, compact }) => {
  const [activeImage, setActiveImage] = useState(0);

  return (
    <div className="service-card" style={{ borderTop: `3px solid ${service.borderColor}` }}>
      <div className="service-header">
        <div className="service-icon">{service.icon}</div>
        <h3 className="service-title">{service.title}</h3>
        
        {/* Shorten the description if it's the compact preview */}
        <p className="service-desc">
          {compact && service.description.length > 120
            ? `${service.description.substring(0, 120)}...`
            : service.description}
        </p>

        {/* Indicator to click for more info */}
        {compact && (
          <div style={{ color: 'var(--red)', fontSize: '11px', marginTop: '16px', letterSpacing: '2px', textTransform: 'uppercase', fontWeight: '500' }}>
            Read full details →
          </div>
        )}
      </div>

      {/* Hide the heavy content (features, tech, case study) when in preview mode */}
      {!compact && (
        <div className="service-content">
          <div className="service-meta">
            <div>
              <h4>Key Features</h4>
              <div className="features-list">
                {service.features.map(feature => (
                  <span key={feature} className="feature-badge">{feature}</span>
                ))}
              </div>
            </div>
            <div>
              <h4>Tech Stack</h4>
              <div className="tech-stack">
                {service.techStack.map(tech => (
                  <span key={tech} className="tech-pill">{tech}</span>
                ))}
              </div>
            </div>
          </div>
          <h4>Proven Impact</h4>
          <div className="case-card">
            <div className="case-gallery">
              <img
                src={service.caseStudy.images[activeImage]}
                alt={service.caseStudy.name}
                className="case-main-image"
              />
              <div className="case-thumbs">
                {service.caseStudy.images.map((src, i) => (
                  <img
                    key={i}
                    src={src}
                    alt={`${service.caseStudy.name}-${i}`}
                    className={`case-thumb ${activeImage === i ? "active" : ""}`}
                    onClick={() => setActiveImage(i)}
                  />
                ))}
              </div>
            </div>
            <div className="case-info">
              <div className="case-name">{service.caseStudy.name}</div>
              <div className="case-role">{service.caseStudy.role}</div>
              <div className="case-result">{service.caseStudy.result}</div>
              <a
                href={service.caseStudy.link}
                target={service.caseStudy.link.startsWith("http") ? "_blank" : "_self"}
                rel="noreferrer"
                className="case-link"
              >
                View Project →
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};